export default __webpack_public_path__ + "static/media/CodingLab.2b67b332.png";